<template>
  <div class="flex h-screen overflow-hidden bg-white">
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog
        as="div"
        static
        class="fixed inset-0 z-40 flex lg:hidden"
        @close="sidebarOpen = false"
        :open="sidebarOpen"
      >
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
        </TransitionChild>
        <TransitionChild
          as="template"
          enter="transition ease-in-out duration-300 transform"
          enter-from="-translate-x-full"
          enter-to="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leave-from="translate-x-0"
          leave-to="-translate-x-full"
        >
          <div
            class="relative flex flex-col flex-1 w-full max-w-xs bg-white focus:outline-none"
          >
            <TransitionChild
              as="template"
              enter="ease-in-out duration-300"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="ease-in-out duration-300"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <div class="absolute top-0 right-0 pt-2 -mr-12">
                <button
                  type="button"
                  class="flex items-center justify-center w-10 h-10 ml-1 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  @click="sidebarOpen = false"
                >
                  <span class="sr-only">Close sidebar</span>
                  <XIcon class="w-6 h-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </TransitionChild>
            <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
              <div class="flex items-center flex-shrink-0 px-4">
                <img
                  class="w-auto h-8"
                  src="./assets/images/_edyta_jordan_logo_vue.png"
                  alt="Edyta & Vue.js"
                />
              </div>
              <nav aria-label="Sidebar" class="mt-5 mainNav">
                <div class="px-2 space-y-1">
                  <TheMainMenu></TheMainMenu>
                </div>
              </nav>
            </div>
            <div class="flex flex-shrink-0 p-4 border-t border-gray-200">
              <a
                href="https://edytajordan.com"
                class="flex-shrink-0 block group"
                target="_blank"
              >
                <div class="flex items-center">
                  <div>
                    <img
                      class="inline-block w-10 h-10 rounded-full"
                      src="./assets/images/1516554117722.jpeg"
                      alt="Edyta Jordan"
                    />
                  </div>
                  <div class="ml-3">
                    <p
                      class="text-base font-medium text-gray-700 group-hover:text-gray-900"
                    >
                      Edyta Jordan
                    </p>
                    <p
                      class="text-sm font-medium text-gray-500 group-hover:text-gray-700"
                    >
                      Main Website
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </TransitionChild>
        <div class="flex-shrink-0 w-14" aria-hidden="true">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden lg:flex lg:flex-shrink-0">
      <div class="flex flex-col w-64">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div
          class="flex flex-col flex-1 h-0 bg-gray-100 border-r border-gray-200"
        >
          <div class="flex flex-col flex-1 pt-5 pb-4 overflow-y-auto">
            <div
              class="flex items-center flex-shrink-0 px-4 border-b border-gray-200"
            >
              <img
                class="w-auto h-8 mb-2"
                src="./assets/images/_edyta_jordan_logo_vue.png"
                alt="Edyta Jordan & Vue.js"
              />
            </div>
            <nav class="flex-1 mt-5 mainNav" aria-label="Sidebar">
              <div class="px-2 space-y-1">
                <TheMainMenu></TheMainMenu>
              </div>
            </nav>
          </div>
          <div class="flex flex-shrink-0 p-4 border-t border-gray-200">
            <a
              href="https://edytajordan.com"
              class="flex-shrink-0 block w-full group"
              target="_blank"
            >
              <div class="flex items-center">
                <div>
                  <img
                    class="inline-block rounded-full h-9 w-9"
                    src="./assets/images/1516554117722.jpeg"
                    alt=""
                  />
                </div>
                <div class="ml-3">
                  <p
                    class="text-sm font-medium text-gray-700 group-hover:text-gray-900"
                  >
                    Edyta Jordan
                  </p>
                  <p
                    class="text-xs font-medium text-gray-700 group-hover:text-gray-900"
                  >
                    Main Website
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
      <div class="lg:hidden">
        <div
          class="flex items-center justify-between bg-gray-50 border-b border-gray-200 px-4 py-1.5"
        >
          <div>
            <img
              class="w-auto h-8"
              src="./assets/images/_edyta_jordan_logo_vue.png"
              alt="Edyta Jordan & Vue.js"
            />
          </div>
          <div>
            <button
              type="button"
              class="inline-flex items-center justify-center w-12 h-12 -mr-3 text-gray-500 rounded-md hover:text-gray-900"
              @click="sidebarOpen = true"
            >
              <span class="sr-only">Open sidebar</span>
              <MenuIcon class="w-6 h-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
      <div class="relative z-0 flex flex-1 overflow-hidden">
        <main
          class="relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last"
        >
          <!-- Start main area-->
          <div class="absolute inset-0 p-0">
            <router-view></router-view>
            <router-view name="footer"></router-view>
          </div>
          <!-- End main area -->
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue';
import { MenuIcon, XIcon } from '@heroicons/vue/outline';
import TheMainMenu from './components/UI/TheMainMenu';

export default {
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    TheMainMenu,
    MenuIcon,
    XIcon
  },

  data() {
    return {
      teams: [
        {
          id: 't1',
          name: 'Frontend Engineers',
          members: ['u1', 'u2'],
          initials: 'FE',
          href: '#',
          bgColor: 'bg-pink-600'
        },
        {
          id: 't2',
          name: 'Backend Engineers',
          members: ['u1', 'u2', 'u3'],
          initials: 'BE',
          href: '#',
          bgColor: 'bg-purple-600'
        },
        {
          id: 't3',
          name: 'Client Consulting',
          members: ['u4', 'u5'],
          initials: 'CC',
          href: '#',
          bgColor: 'bg-yellow-600'
        }
      ],
      users: [
        {
          id: 'u1',
          fullName: 'Max Schwarz',
          role: 'Engineer',
          imageUrl:
            'https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80'
        },
        {
          id: 'u2',
          fullName: 'Praveen Kumar',
          role: 'Engineer',
          imageUrl:
            'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixqx=6HhJqzk017&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
        },
        {
          id: 'u3',
          fullName: 'Julie Jones',
          role: 'Engineer',
          imageUrl:
            'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixqx=6HhJqzk017&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
        },
        {
          id: 'u4',
          fullName: 'Alex Blackfield',
          role: 'Consultant',
          imageUrl:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixqx=6HhJqzk017&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
        },
        {
          id: 'u5',
          fullName: 'Marie Smith',
          role: 'Consultant',
          imageUrl:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60'
        }
      ]
    };
  },

  provide() {
    return {
      teams: this.teams,
      users: this.users
    };
  },

  setup() {
    const sidebarOpen = ref(false);

    return {
      sidebarOpen
    };
  },
  mounted() {
    //console.log(this.$router.options.routes);
  },
  created() {
    this.$store.dispatch('tryLogin');
  }
};
</script>
